import {createReducer, on} from '@ngrx/store';
import * as fromCore from '../actions/core.actions';
import {IUser} from '../../../shared/interfaces/IUser';
import {IClient} from '../../../shared/interfaces/IClient';

export const coreFeatureKey = 'core';

export interface State {
  isLogged: boolean;
  isLoading: boolean;
  user: IClient;
}

export const initialState: State = {
  isLogged: false,
  isLoading: false,
  user: null
};

const _Reducer = createReducer(
  initialState,
  on(fromCore.getUser, (state) => ({...state, isLoading: true})),
  on(fromCore.getUserSuccess, (state, payload) => ({...state, isLoading: false, isLogged: true, user: payload.user})),
  on(fromCore.getUserError, (state, payload) => ({...state, isLoading: false, isLogged: false, user: null})),
  on(fromCore.setUserLogged, (state, payload) => ({...state, isLogged: payload.logged})),
);

export function reducer(state, action): State {
  return _Reducer(state, action);
}
